module.exports = __webpack_public_path__ + "static/notre_choix-1cf0799194e84e1d7a4cc2ebe1557a09.png";